import { UserDetailsDto } from '@/api/generated';
import { UserContext, UserContextProps } from '@/utils/providers/userContext/UserContext.tsx';
import React, { PropsWithChildren, useMemo, useState } from 'react';

export const UserProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [user, setUser] = useState<UserDetailsDto | undefined>(undefined);
  const [isInitialized, setIsInitialized] = useState(false);

  const context: UserContextProps = useMemo(() => {
    return {
      isInitialized,
      setIsInitialized,
      setUser,
      user,
    };
  }, [isInitialized, user]);

  return <UserContext.Provider value={context}>{children}</UserContext.Provider>;
};
